import React from "react";
import { Link } from "react-router-dom";
import Typography from "@material-ui/core/Typography";

const Copyright = () => {
	return (
		<Typography variant="body2" color="textSecondary" align="center">
			{"Copyright © "}
			<Link to="/">{process.env.REACT_APP_APP_NAME}</Link> {new Date().getFullYear()}
			{" "}
			{"By "}
			<Link href="https://github.com/goldenfay">{"Goldenfay"}</Link>
			{" | "}
			{"All rights reserved"}
			{"."}
		</Typography>
	);
};

export default Copyright;
